import theme from '../../themes/theme';
import icons from '../../themes/assets';
// const EventIcon = require('../../themes/assets/icons/Event.svg');
// const AlertIcon = require('../../themes/assets/icons/Alert.svg');
// const NaviIcon = require('../../themes/assets/icons/Navi.svg');

const {
  Layout: { avatarIcon },
  notificationAvatar,
} = theme;

export const NotificationAvatarIcons = {
  UNKNOWN_CATEGORY: {
    icon: icons.NaviIcon,
    fillColor: notificationAvatar.reminder,
    svgId: 'Custom/Default',
  }, // Default value on error
  SERVICE_ALERT: {
    icon: icons.AlertIcon,
    fillColor: notificationAvatar.service,
    svgId: 'Custom/Phone',
  },
  CALENDAR_ALERT: {
    icon: icons.EventIcon,
    fillColor: notificationAvatar.calendar,
    svgId: 'Custom/Event',
  },
  RENEWAL_ALERT: {
    icon: icons.AlertIcon,
    fillColor: notificationAvatar.renewal,
    svgId: 'Custom/Alert',
  },
  RECALL_ALERT: {
    icon: icons.AlertIcon,
    fillColor: notificationAvatar.recall,
    svgId: 'Custom/Alert',
  },
  MARKETPLACE_ALERT: {
    icon: icons.NaviIcon,
    fillColor: notificationAvatar.marketPlace,
    svgId: 'Custom/Default',
  },
  REMINDER: {
    icon: icons.AlertIcon,
    fillColor: notificationAvatar.reminder,
    svgId: 'Custom/Alert',
  },
  HOME_ALERT: {
    icon: icons.AlertIcon,
    fillColor: notificationAvatar.home,
    svgId: 'Custom/Alert',
  },
  REMOTE_AUTH_ALERT: {
    icon: icons.AlertIcon,
    fillColor: notificationAvatar.remothAuth,
    svgId: 'Custom/Alert',
  },
  WEATHER_ALERT: {
    icon: icons.AlertIcon,
    fillColor: notificationAvatar.weather,
    svgId: 'Custom/Phone',
  },
  SEND_TO_CAR_ALERT: {
    icon: icons.AlertIcon,
    fillColor: notificationAvatar.sendToCar,
    svgId: 'Custom/Phone',
  },
};
